import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogCustomHeader,
  DialogPrimaryActions,
  Heading,
  IconBox,
  Text,
} from '@compono/ui';
import { ExclamationTriangleSolidIcon } from '@compono/ui-icons';

interface Props {
  title: string;
  mainDescription: string;
  subDescription?: string;
  confirmButtonLook?: string;
  confirmButtonTone?: string;
  confirmText?: string;
  onSubmit: () => void;
  onClose: () => void;
}

const DeleteConfirmation = ({
  title,
  mainDescription,
  subDescription,
  confirmButtonLook: cancelButtonLook,
  confirmButtonTone: cancelButtonTone,
  confirmText: cancelButtonLabel,
  onSubmit,
  onClose,
}: Props) => (
  <Box>
    <Dialog
      isOpen={true}
      aria-describedby="dialog-description-onDismiss"
      aria-labelledby="dialog-title-onDismiss"
    >
      <DialogCustomHeader>
        <Box
          sx={{
            pt: 7,
            pb: 5,
            color: 'critical.60',
            textAlign: 'center',
          }}
        >
          <Heading level="5" component="h2">
            <Box sx={{ textAlign: 'center', fontSize: 20 }}>
              <IconBox
                sx={{
                  fontSize: '32px',
                  display: 'block',
                  mb: 3,
                }}
              >
                <ExclamationTriangleSolidIcon />
              </IconBox>
              {title}
            </Box>
          </Heading>
        </Box>
      </DialogCustomHeader>
      <DialogBody id="dialog-description-onDismiss" tone="lightgrey">
        <Box
          sx={{
            p: 1,
            display: 'grid',
            gridGap: 5,
          }}
        >
          <Text font="title">{mainDescription}</Text>
          <Text>{subDescription}</Text>
        </Box>
      </DialogBody>
      <DialogPrimaryActions>
        <Button look="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          data-test-id="delete-button"
          onClick={onSubmit}
          look={cancelButtonLook}
          tone={cancelButtonTone}
        >
          {cancelButtonLabel ?? `Continue`}
        </Button>
      </DialogPrimaryActions>
      <DialogCloseButton onClick={onClose} />
    </Dialog>
  </Box>
);

export default DeleteConfirmation;
